const defaultPriorities = [
    { id: 1, color: "#FE6158", label: "High" },
    { id: 2, color: "#F1B941", label: "Medium" },
    { id: 3, color: "#77D257", label: "Low" },
];
const defaultColors = ["#33B0B4", "#0096FA", "#F1B941"];
export const defaultCardShape = {
    label: {
        show: true,
    },
    description: {
        show: false,
    },
    progress: {
        show: false,
    },
    start_date: {
        show: false,
    },
    end_date: {
        show: false,
    },
    users: {
        show: false,
    },
    priority: {
        show: false,
        values: defaultPriorities,
    },
    color: {
        show: false,
        values: defaultColors,
    },
    cover: {
        show: false,
    },
    attached: {
        show: false,
    },
    menu: {
        show: true,
    },
};
export const defaultEditorShape = [
    {
        key: "label",
        type: "text",
        label: "Label",
    },
    {
        key: "description",
        type: "textarea",
        label: "Description",
    },
    {
        type: "combo",
        label: "Priority",
        key: "priority",
        config: {
            clearButton: true,
        },
    },
    {
        type: "color",
        label: "Color",
        key: "color",
    },
    {
        type: "progress",
        key: "progress",
        label: "Progress",
    },
    {
        type: "date",
        key: "start_date",
        label: "Start date",
    },
    {
        type: "date",
        key: "end_date",
        label: "End date",
    },
    {
        type: "multiselect",
        key: "users",
        label: "Users",
    },
];
export const defaultEditorConfig = {
    debounce: 100,
    autoSave: true,
};
export const elementsIds = {
    kanban: "wx-kanban",
    toolbar: "wx-kanban-toolbar",
    editor: "wx-kanban-editor",
    content: "wx-kanban-content",
    scrollableContent: "wx-kanban-scrollable-content",
    search: "wx-kanban-search",
};
export const customIcons = {
    "wxi-message": {
        path: "M8.88 22.2C8.586 22.2 8.303 22.083 8.095 21.875 7.887 21.667 7.77 21.384 7.77 21.09V17.76H3.33C2.741 17.76 2.177 17.526 1.76 17.11 1.344 16.694 1.11 16.129 1.11 15.54V2.22C1.11.988 2.109 0 3.33 0H21.09C21.679 0 22.244.234 22.66.65 23.076 1.067 23.31 1.631 23.31 2.22V15.54C23.31 16.129 23.076 16.694 22.66 17.11 22.244 17.526 21.679 17.76 21.09 17.76H14.319L10.212 21.878C9.99 22.089 9.713 22.2 9.435 22.2H8.88ZM9.99 15.54V18.959L13.409 15.54H21.09V2.22H3.33V15.54H9.99Z",
    },
    "wxi-like": {
        path: "M5,9V21H1V9H5M9,21A2,2 0 0,1 7,19V9C7,8.45 7.22,7.95 7.59,7.59L14.17,1L15.23,2.06C15.5,2.33 15.67,2.7 15.67,3.11L15.64,3.43L14.69,8H21C22.11,8 23,8.9 23,10V12C23,12.26 22.95,12.5 22.86,12.73L19.84,19.78C19.54,20.5 18.83,21 18,21H9M9,19H18.03L21,12V10H12.21L13.34,4.68L9,9.03V19Z",
    },
};
export const getSortConfig = () => {
    return [
        {
            by: "label",
            dir: "asc",
            text: "Label (a-z)",
            id: 7,
        },
        {
            by: "label",
            dir: "desc",
            text: "Label (z-a)",
            id: 8,
        },
        {
            by: "description",
            dir: "asc",
            text: "Description (a-z)",
            id: 9,
        },
        {
            by: "description",
            dir: "desc",
            text: "Description (z-a)",
            id: 10,
        },
    ];
};
export const getDefaultCardMenuItems = ({ store }) => {
    const { readonly } = store.getState();
    const baseItems = [
        { id: "duplicate-card", icon: "wxi-content-copy", text: "Duplicate" },
        { id: "delete-card", icon: "wxi-delete-outline", text: "Delete" },
    ];
    if (!readonly?.select && readonly?.edit) {
        return [
            { id: "set-edit", icon: "wxi-edit-outline", text: "Edit" },
            ...baseItems,
        ];
    }
    return baseItems;
};
export const getDefaultColumnMenuItems = ({ columns, columnIndex, }) => [
    { id: "add-card", icon: "wxi-plus", text: "Add new card" },
    { id: "set-edit", icon: "wxi-edit-outline", text: "Rename" },
    {
        id: "move-column:left",
        icon: "wxi-arrow-left",
        text: "Move left",
        disabled: columnIndex <= 0,
    },
    {
        id: "move-column:right",
        icon: "wxi-arrow-right",
        text: "Move right",
        disabled: columnIndex >= columns.length - 1,
    },
    { id: "delete-column", icon: "wxi-delete-outline", text: "Delete" },
];
export const getDefaultRowMenuItems = ({ rows, rowIndex, }) => [
    { id: "set-edit", icon: "wxi-edit-outline", text: "Rename" },
    {
        id: "move-row:up",
        icon: "wxi-arrow-up",
        text: "Move up",
        disabled: rowIndex <= 0,
    },
    {
        id: "move-row:down",
        icon: "wxi-arrow-down",
        text: "Move down",
        disabled: rowIndex >= rows.length - 1,
    },
    { id: "delete-row", icon: "wxi-delete-outline", text: "Delete" },
];
//# sourceMappingURL=constants.js.map